import { RootState } from '../../../../config/store/rootReducer';

export const makeIsPendingSelector = (action: string) => (state: RootState): boolean =>
  Boolean(state.loading[action] === undefined || state.loading[action]);

export const makeActionRequestIsPendingSelector = (action: string) => (state: RootState): boolean =>
  Boolean(state.loading[action]);
